import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import useMemberTable from '../context/MemberTableContext'
import { QueryClient, useQuery } from '@tanstack/react-query'
import Loader from '../../../../common/loader/Loader'
import Card from '../../../../common/card/Card'
import JoinRequestsTable from './JoinRequestsTable'

const JoinRequests = ({ teamType }) => {

  const params = useParams()
  const teamId = params.team_id ?? 0
  const [ responseMessage, setResponseMessage ] = useState('')
  const { setRefetchJoinRequests, setSelectedUser, setSelectedModal, setSelectedBulkUser } = useMemberTable()

  const queryClient = new QueryClient()

  const {
    isLoading,
    isPending,
    isFetching,
    isError,
    error,
    refetch,
    data } = useQuery({
      queryKey: ['msync_get_org_join_requests'],
      queryFn: requestOrgJoinRequests,
      refetchOnWindowFocus: false
    }, queryClient)

    async function requestOrgJoinRequests() {
      const currentRestUrl = window.group_dashboard.base
      const nonce = window.group_dashboard.nonce
      const url = currentRestUrl + 'membersync/licensing/v1/org/' + teamId + '/enrollments'

      try {
        const res = await fetch(url, {
            method: 'GET',
            headers:{
                'X-WP-Nonce': nonce,
                'Content-type': 'application/json'
            }
        })

        if ( !res.ok ) throw Error(res.statusText)

        const resultJSON = await res.json()
        return resultJSON.response
      } catch (error) {
        console.log(error)
        setResponseMessage( error.toString() )
        return false
      }
    }

    useEffect(() => {
      setRefetchJoinRequests(() => refetch)
      setSelectedUser('')
      setSelectedModal('')
      setSelectedBulkUser('')
    }, [ refetch ])

    if( isLoading || isPending || isFetching ){
      return (
        <Loader type='spinner-dual-ring'/>
      )
    }
  
    if( isError ){
      return (
        <Card> 
          <strong> { error.message } </strong> 
        </Card>
      )
    }

  return (
    <>
      {
        responseMessage && responseMessage !== ''
        ? <Card> 
            <strong>{ responseMessage }</strong> 
          </Card>
        : data && 
          <JoinRequestsTable joinRequestsData={ data } />
      }
    </>
  )
}

export default JoinRequests
